import { useLocation } from "@tanstack/react-router";

import { AdminTabNav } from "./AdminTabNav";

export default function AdminTabs() {
  const location = useLocation();

  return <AdminTabNav currentPath={location.pathname} />;
}
